import type { MutationHookOptions } from '@apollo/client'
import { SessionsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  CreateTrainingsSessionDocument,
  CreateTrainingsSessionMutation,
  CreateTrainingsSessionMutationVariables,
  TrainingClassesDocument,
  TrainingDetailPageDocument,
  TrainingSessionsDocument,
  TrainingSessionsFiltersDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingsSessionMutation,
  CreateTrainingsSessionMutationVariables
>

export const useCreateSession = (options?: Options) => {
  const [createSession, { loading }] = useMutation(CreateTrainingsSessionDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.createTrainingsSession,
  })

  return {
    loading,
    create(variables: CreateTrainingsSessionMutationVariables) {
      return createSession({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          SessionsDataTableDocument,
          TrainingClassesDocument,
          TrainingDetailPageDocument,
          TrainingSessionsDocument,
          TrainingSessionsFiltersDocument,
        ],
      })
    },
  }
}
